<template>
  <div>
    <div style="background: white">
      <el-descriptions :column="1" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-location-information"></i> 答卷IP
          </template>
          {{ survey.surveyAnswer.ipAddr }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-timer"></i>
            答卷时间
          </template>
          {{ survey.surveyAnswer.endAnDate }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-monitor"></i>
            答题数
          </template>
          {{ survey.surveyAnswer.completeItemNum }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="dw-answer-title">答卷结果信息</div>
      <div style="padding: 0px 10px 20px 10px">
        <dw-survey-answer-qu-common
          v-for="(item, index) in survey.questions"
          :key="item.id"
          :id="item.id"
          :index="index"
          :question="item"
        ></dw-survey-answer-qu-common>
      </div>
    </div>
  </div>
</template>
<script>
import DwSurveyDcsWrapper from "@/components/common/DwSurveyDcsWrapper";
import DwSurveyAnswerQuCommon from "@/views/dw-survey/dw-data/wx/indexcommon";
import { dwSurveyAnswerInfo } from "@/api/dw-survey";

export default {
  name: "DwSurveyAnswerInfo",
  components: {
    DwSurveyDcsWrapper,
    DwSurveyAnswerQuCommon,
  },
  data() {
    return {
      survey: {
        questions: [],
      },
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      radio: 3,
      formSize: "medium",
      rateValue: 3.7,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      options: [],
      value: "",
    };
  },
  mounted() {
    this.querySurveyAnswer(1);
  },
  methods: {
    handleInfo(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    querySurveyAnswer() {
      console.log(this.$route.params);
      dwSurveyAnswerInfo(this.$route.params.answerId).then((response) => {
        const resultData = response.data.data;
        console.log(resultData);
        this.survey = resultData;
        for (let i = 0; i < this.survey.questions.length; i++) {
          const questionData = this.survey.questions[i];
          const quType = questionData.quType;
          let quOptionsObj;
          if (quType === "CHECKBOX") {
            questionData.quTypeName = "多选题";
            quOptionsObj = questionData.quCheckboxs;
          } else if (quType === "RADIO") {
            questionData.quTypeName = "单选题";
            quOptionsObj = questionData.quRadios;
          } else if (quType === "FILLBLANK") {
            questionData.quTypeName = "填空题";
          } else if (quType === "SCORE") {
            questionData.quTypeName = "评分题";
            quOptionsObj = questionData.quScores;
          } else if (quType === "ORDERQU") {
            questionData.quTypeName = "排序题";
            quOptionsObj = questionData.quOrderbys;
          } else if (quType === "MULTIFILLBLANK") {
            questionData.quTypeName = "多项填空题";
            quOptionsObj = questionData.quMultiFillblanks;
          } else if (quType === "UPLOADFILE") {
            questionData.quTypeName = "文件上传题";
          } else {
            questionData.quTypeName = quType;
          }
          if (
            quType === "CHECKBOX" ||
            quType === "SCORE" ||
            quType === "ORDERQU" ||
            quType === "MULTIFILLBLANK"
          ) {
            for (let j = 0; j < quOptionsObj.length; j++) {
              const item = quOptionsObj[j];
              if (quType === "CHECKBOX") {
                const anCheckboxs = questionData.anCheckboxs;
                for (let k = 0; k < anCheckboxs.length; k++) {
                  if (anCheckboxs[k].quItemId === item.id) {
                    item.answer = true;
                    break;
                  }
                }
              } else if (quType === "SCORE") {
                const anScores = questionData.anScores;
                for (let k = 0; k < anScores.length; k++) {
                  if (anScores[k].quRowId === item.id) {
                    if (anScores[k].answserScore != null) {
                      item.answer = parseInt(anScores[k].answserScore);
                      break;
                    }
                  }
                }
              } else if (quType === "ORDERQU") {
                const anOrders = questionData.anOrders;
                for (let k = 0; k < anOrders.length; k++) {
                  if (anOrders[k].quRowId === item.id) {
                    item.answer = anOrders[k].orderyNum;
                    break;
                  }
                }
              } else if (quType === "MULTIFILLBLANK") {
                const anDFillblanks = questionData.anDFillblanks;
                for (let k = 0; k < anDFillblanks.length; k++) {
                  if (anDFillblanks[k].quItemId === item.id) {
                    item.answer = anDFillblanks[k].answer;
                    break;
                  }
                }
              }
            }
          }
        }
      });
    },
    handleCurrentChange: function (val) {},
  },
};
</script>
<style scoped>
.dw-answer-title {
  font-size: 16px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-survey/dw-data/wx/index.vue